
<template>
  <eye-exam-card
    class="medical-record-exam-view"
    title="Galilei"
    :patient-id="patientId"
    :record-id="recordId"
    :exam-id="examId"
    :inputs="data"
    :rows-definition="table.body"
    :date="date"
    @edit="$emit('edit')"
    :show-edit-button="showEditButton"
  />
</template>

<script>
import formatters from '@/filters';
import EyeExamCard from '../ophtalmology/EyeExamCard.vue';

export default {
  name: 'GalileiView',
  components: {
    EyeExamCard,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    showEditButton: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      table: {
        body: [
          {
            label: 'Astigmatismo DK',
            R: 'astigmatismDkR',
            L: 'astigmatismDkL',
            formatter: formatters.diopter,
          },
          {
            label: 'K1 (Flat plano)',
            R: ['k1R', 'k1AxisR'],
            L: ['k1L', 'k1AxisL'],
            formatter: this.formatKeratometry,
          },
          {
            label: 'K2 (Steep curvo)',
            R: ['k2R', 'k2AxisR'],
            L: ['k2L', 'k2AxisL'],
            formatter: this.formatKeratometry,
          },
          {
            label: 'Ponto mais fino (Thinnest)',
            R: 'thinnestPointR',
            L: 'thinnestPointL',
            formatter: formatters.micron,
          },
          {
            label: 'Dist. KAPPA',
            R: 'kappaDistanceR',
            L: 'kappaDistanceL',
            formatter: v => formatters.millimeter(v, 2),
          },
          {
            label: 'KPI',
            R: 'kpiR',
            L: 'kpiL',
            formatter: v => formatters.percent(v, 1),
          },
          {
            label: 'I-S',
            R: 'isR',
            L: 'isL',
            formatter: formatters.number,
          },
          {
            label: 'BFTA Posterior',
            R: 'postBftaR',
            L: 'postBftaL',
            formatter: v => formatters.micron(v, 2),
          },
          {
            label: 'Kmax',
            R: 'kmaxR',
            L: 'kmaxL',
            formatter: formatters.diopter,
          },
        ],
      },
    };
  },
  methods: {
    formatKeratometry(value, axis) {
      if (!value && !axis) return '';
      return [formatters.number(value), formatters.deg(axis)].filter(v => v !== '').join(' @ ');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
</style>
